import type {
  Aggregation,
  DashboardView,
  DomainRule,
  MetricKey,
  Visualization,
  WidgetConfig,
} from '@contracts';
import { METRIC_CATALOG } from '@contracts';
import type { WidgetSuggestion } from '@/services/assistantService';

/**
 * Sugerencia del asistente ("agregar al tablero") → `WidgetConfig` para `addWidget`.
 * Devuelve `null` si la sugerencia no mapea a un widget válido.
 */
export function suggestionToConfig(
  s: WidgetSuggestion,
  view: DashboardView,
  period: WidgetConfig['period'],
): { config: WidgetConfig; label: string } | null {
  if (s.kind === 'metric' && s.metric) {
    const entry = METRIC_CATALOG.find((m) => m.key === s.metric);
    if (!entry) return null;
    return {
      label: entry.label,
      config: {
        metric: s.metric as MetricKey,
        visualization: entry.defaultVisualization,
        view: (s.view as DashboardView) ?? view,
        period,
        title: entry.label,
      },
    };
  }
  if (s.kind === 'custom' && s.query) {
    const q = s.query;
    const label = `${q.model} · ${q.aggregation}`;
    return {
      label,
      config: {
        metric: null,
        customQuery: {
          model: q.model,
          aggregation: q.aggregation as Aggregation,
          field: q.field ?? undefined,
          domain: (q.domain ?? []) as DomainRule[],
          groupBy: q.groupBy ?? undefined,
          groupLimit: 20,
          visualization: q.visualization as Visualization,
        },
        visualization: q.visualization as Visualization,
        view,
        period,
        title: label,
      },
    };
  }
  return null;
}
